import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
           <div className="col-md-7">
            <div className="pq-section pq-style-1 text-center">
               <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What is an intratympanic steroid injection?", answer: "It is a minimally invasive ENT procedure where steroid medicine is delivered directly into the middle ear. This helps reduce inflammation and improve inner-ear conditions such as sudden hearing loss, tinnitus, and vertigo. It provides targeted treatment with fewer systemic side effects." },
                  { question: "Who should consider this treatment?", answer: "Patients with Sudden Sensorineural Hearing Loss (SSNHL), Ménière’s disease, severe tinnitus, or those who did not respond well to oral steroids may be advised this injection. It delivers high-dose steroids directly to the inner ear, improving outcomes in many cases." },
                  { question: "Is the procedure painful or risky?", answer: "The injection is usually well-tolerated. A local anaesthetic is used, so only mild pressure or slight discomfort may be felt. Risks are minimal and may include temporary dizziness, ear fullness, or mild pain. Serious complications are rare when performed by an experienced ENT specialist." },
                  {question: "How long does the procedure take and what is recovery like?", answer: "The procedure takes 10–15 minutes. Patients are asked to lie still for a short time after the injection. Normal activities can be resumed the same day. Some may feel temporary ear fullness or mild imbalance, which usually settles quickly."},
                  {question: "How many injections are needed for best results?", answer: "The number of injections varies with your condition. Many patients need 2–4 injections spaced a few days apart. Your ENT specialist will decide based on your hearing test results, severity of symptoms, and response to treatment."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            </div>
            <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                     <iframe width="100%" height="315" src="https://www.youtube.com/embed/_mrZr-qAzFA?si=uD0oMBK_ZrSCEcE8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Vertigo Relief: IntraTympanic Steroid Injection Explained | Rapid Vertigo Relief Treatment</h5></div>
          </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
